var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBattery0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11854_12462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 22.103C8.33334 22.4849 8.64584 22.7974 9.02778 22.7974H15.9722C16.3542 22.7974 16.6667 22.4849 16.6667 22.103V5.43631C16.6667 5.05436 16.3542 4.74186 15.9722 4.74186H9.02778C8.64584 4.74186 8.33334 5.05436 8.33334 5.43631L8.33334 22.103ZM9.02778 25.5752C7.10938 25.5752 5.55556 24.0214 5.55556 22.103L5.55556 5.43631C5.55556 3.5179 7.10938 1.96408 9.02778 1.96408H9.72222C9.72222 1.19586 10.3429 0.575195 11.1111 0.575195H13.8889C14.6571 0.575195 15.2778 1.19586 15.2778 1.96408H15.9722C17.8906 1.96408 19.4444 3.5179 19.4444 5.43631V22.103C19.4444 24.0214 17.8906 25.5752 15.9722 25.5752H9.02778Z",
    fill: "#132439"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11854_12462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 25.5752)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery0);
export default __webpack_public_path__ + "static/media/battery_0.9b92a2fb734b50a3a18ddfdc6f9a8763.svg";
export { ForwardRef as ReactComponent };